export default __webpack_public_path__ + "static/media/legacy-zil.fec8514c.svg";